import React from 'react'
import { Link } from '@inertiajs/react'
import { Chip } from '@mui/material'
import FavoriteIcon from '@mui/icons-material/Favorite'

interface Props {
  group: { id: number; name: string; color: string }
  size?: 'small' | 'medium'
  withIcon?: boolean
  onDelete?: () => void
}

// Returns a readable text colour (dark for light bgs, light for dark bgs) for
// a given #RRGGBB hex. Uses the YIQ luma formula so the threshold is
// perception-weighted (green/red dominate over blue).
function readableTextOn(hex: string): string {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex)
  if (!m) return '#1A1033'
  const r = parseInt(m[1].slice(0, 2), 16)
  const g = parseInt(m[1].slice(2, 4), 16)
  const b = parseInt(m[1].slice(4, 6), 16)
  const luma = (r * 299 + g * 587 + b * 114) / 1000
  return luma >= 160 ? '#1A1033' : '#FFFFFF'
}

export default function GroupChip({ group, size = 'small', withIcon = true, onDelete }: Props) {
  const bg = group.color
  const fg = readableTextOn(bg)

  return (
    <Chip
      component={Link}
      href={`/groups/${group.id}`}
      clickable
      label={group.name}
      size={size}
      icon={withIcon ? <FavoriteIcon sx={{ fontSize: 14, color: 'inherit !important' }} /> : undefined}
      onDelete={onDelete}
      sx={{
        backgroundColor: bg,
        color: fg,
        border: `1px solid ${bg}`,
        fontWeight: 600,
        '& .MuiChip-icon': { color: fg, ml: 0.5 },
        '& .MuiChip-deleteIcon': { color: fg },
        '&:hover': { backgroundColor: bg, filter: 'brightness(0.92)' },
      }}
    />
  )
}
